import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import Request from "../../../../helpers/request";
import * as url from "../../../../helpers/url_helper";
import { convertProfileLocalDate } from "../../../../Utils/configController";
import ChipsList from "./ChipsDetail/ChipsList";
import BlasterList from "./BlasterList";
import LockList from "./LockList";
import CurtainList from "./CurtainList";
import ScheduleList from "./ScheduleList";
import DeviceList from "./DeviceList";
import { Images } from "../../../../constants/images";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import {
  selectedPremiseRooms,
  selectedPremiseRoomsList,
  setSelectedProfileDetails,
} from "../../../../store/slices/APIResponseSlice";
import { useSelector } from "react-redux";
import UserAction from "./UserAction";
import SceneList from "./SceneList";
import DriverList from "./DriverList";
import SharedUsersList from "./SharedUsersList";
import AutomationList from "./AutomationList";
import { Tooltip } from "react-tooltip";
import UserSettingModal from "./UserSettingModal";

const tabs = [
  { key: "chips", label: "Chips", component: ChipsList },
  { key: "blaster", label: "Blaster", component: BlasterList },
  { key: "lock", label: "Lock", component: LockList },
  { key: "curtain", label: "Curtain", component: CurtainList },
  { key: "driver", label: "Driver", component: DriverList },
  { key: "scene", label: "Scene", component: SceneList },
  { key: "schedule", label: "Schedule", component: ScheduleList },
  { key: "Automation", label: "Automation", component: AutomationList },
  { key: "device", label: "Device", component: DeviceList },
  // { key: "logs", label: "Logs", component: UserAction },
];

const ProfileList = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any[]>([]);
  const [deviceDetails, setDeviceDetails] = useState<any[]>([]);
  const [premiseList, setPremiseList] = useState<any[]>([]);
  const [selectedPremise, setSelectedPremise] = useState<any>("");
  const [isOpenProModal, setOpenProModal] = useState<boolean>(false);
  // const [selectedPremiseRooms, setSelectedPremiseRooms] = useState<any[]>([]);

  const [roomList, setRoomList] = useState<any[]>([]);
  const [sharedList, setsharedList] = useState<any[]>([]);
  const [parentList, setParentList] = useState<any[]>([]);
  const [isVacationMode, setIsVacationMode] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string | null>(null);
  const [mobileGrid, setMobileGrid] = useState<number>(0);
  const [tabGrid, settabGrid] = useState<number>(0);
  const [isSearchBar, setSearchBar] = useState<boolean>(false);
  const [noOfDeviceLimit, setNoOfDeviceLimit] = useState<number>(0);

  interface Streak {
    count: number;
    lastStreakDate: string;
  }

  const [streak, setStreak] = useState<Streak>({
    count: 0,
    lastStreakDate: "",
  });

  const handleTabChange = (tab: string) => {
    if (selectedTab !== tab) setSelectedTab(tab);
  };

  const changeProPremise = () => {
    setLoading(true);
    const reqObj = {
      premiseId: selectedPremise?.id,
      isPro: selectedPremise?.isPro ? false : true,
    };

    Request.post(url.CHANGE_PREMISE_PRO, reqObj)
      .then((res) => {
        getProfileListDetail();
        setLoading(false);
        toggleProModal();
        toast.success(res.data.msg);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getProfileListDetail = () => {
    setLoading(true);
    const reqObj = {
      userId: params.id,
    };
    Request.post(url.GET_PROFILE_LIST_DETAILS, reqObj)
      .then((res) => {
        const data = res.data;
        setStreak({
          count: data?.data?.noOfStreak ?? 0,
          lastStreakDate: data?.data?.lastStreakDate ?? "",
        });

        setMobileGrid(data?.data?.mobileGrid ?? 0);
        settabGrid(data?.data?.tabGrid ?? 0);
        setSearchBar(data?.data?.isSearchBar ?? false);
        setNoOfDeviceLimit(data?.data?.noOfDeviceLimit ?? 0);

        dispatch(
          setSelectedProfileDetails({
            id: data?.data?.id ?? null,
            firstname: data?.data?.firstname ?? null,
            lastname: data?.data?.lastname ?? null,
            email: data?.data?.email ?? null,
            mobile: data?.data?.mobile ?? null,
          })
        );
        setProfileDetails([
          {
            name: "User Id",
            data: `#${data?.data?.id}`,
          },
          {
            name: "Name",
            data: `${data?.data?.firstname} ${data?.data?.lastname}`,
          },
          {
            name: "Email",
            data: data?.data?.email ? data?.data?.email : "--",
          },
          {
            name: "Mobile",
            data: data?.data?.mobile ? data?.data?.mobile : "--",
          },
          {
            name: "Address",
            data: data?.data?.address ? data?.data?.address : "--",
          },
          {
            name: "Created At",
            data: data?.data?.createdAt
              ? convertProfileLocalDate(data?.data?.createdAt)
              : "--",
          },
          {
            name: "Last login",
            data: data?.data?.lastLogin
              ? convertProfileLocalDate(data?.data?.lastLogin)
              : "--",
          },
          {
            name: "Last Action",
            data: data?.data?.lastAction
              ? convertProfileLocalDate(data?.data?.lastAction)
              : "--",
          },
          {
            name: "Last Online Time",
            data: data?.data?.lastOnlineTime
              ? convertProfileLocalDate(data?.data?.lastOnlineTime)
              : "--",
          },
          {
            name: "Last Offline Time",
            data: data?.data?.lastOfflineTime
              ? convertProfileLocalDate(data?.data?.lastOfflineTime)
              : "--",
          },
        ]);
        setDeviceDetails([
          {
            name: "Chips",
            key: "chips",
            online: data.onlineChips,
            offline: data.offlineChips,
            max: data.maxSignalStrength,
            min: data.minSignalStrength,
            total:
              (Number(data.onlineChips) || 0) +
              (Number(data.offlineChips) || 0),
          },
          {
            name: "Blasters",
            key: "blaster",
            online: data.onlineBlasters,
            offline: data.offlineBlasters,
            max: data.maxSignalBlaster,
            min: data.minSignalBlaster,
            total:
              (Number(data.onlineBlasters) || 0) +
              (Number(data.offlineBlasters) || 0),
          },
          {
            name: "Curtains",
            key: "curtain",
            online: data.onlineAirCurtains,
            offline: data.offlineAirCurtains,
            max: data.maxSignalAirCurtain,
            min: data.minSignalAirCurtain,
            total:
              (Number(data.onlineAirCurtains) || 0) +
              (Number(data.offlineAirCurtains) || 0),
          },
          {
            name: "Drivers",
            key: "driver",
            online: data.onlineAirDrivers,
            offline: data.offlineAirDrivers,
            max: data.maxSignalAirDriver,
            min: data.minSignalAirDriver,
            total:
              (Number(data.onlineAirDrivers) || 0) +
              (Number(data.offlineAirDrivers) || 0),
          },
        ]);

        setPremiseList(data?.premises);
        if (!selectedPremise) {
          setSelectedPremise(data?.premises[0]);
        } else {
          if (
            data?.premises?.filter(
              (premise: any) => premise?.id === selectedPremise?.id
            )
          ) {
            const premise = data?.premises?.filter(
              (premise: any) => premise?.id === selectedPremise?.id
            );
            setSelectedPremise(premise[0]);
          }
        }
        const rooms = [...(data?.rooms || [])]; // Ensure data?.rooms is an array or initialize as an empty array if undefined
        setRoomList(rooms);
        setsharedList(data?.sharedUserList || []);
        setParentList(data?.parentUserList || []);
        setIsVacationMode(data?.data?.vacationMode);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getProfileListDetail();
  }, []);

  const handlePremises = (e: any) => {
    const selectedPremise = premiseList.find(
      (item: any) => item.id === e.target.value
    );
    setSelectedPremise(selectedPremise);
  };

  useEffect(() => {
    if (!selectedPremise?.id) return;
    dispatch(
      selectedPremiseRoomsList(
        roomList.filter((id) => id.premiseId === selectedPremise?.id)
      )
    );

    const rooms = roomList;
    const filteredRooms = rooms.filter((rooms) => rooms.name !== "No Room");
    filteredRooms.unshift({
      name: "No Room",
      id: "noroom",
      premiseId: selectedPremise?.id,
    });
    dispatch(
      selectedPremiseRooms(
        filteredRooms
          .filter((id) => id.premiseId === selectedPremise?.id)
          .map((item, index) => {
            return { ...item, isChecked: true };
          })
      )
    );
    setSelectedTab("chips");
  }, [selectedPremise?.id]);

  const handleRoomChecked = (checkedItem: any) => {
    dispatch(
      selectedPremiseRooms(
        selectedRooms.map((item: any, index: number) => {
          if (item.id === checkedItem.id) {
            return { ...item, isChecked: !item.isChecked };
          } else {
            return { ...item };
          }
        })
      )
    );
  };
  const handleRoomAllChecked = (bool: boolean) => {
    dispatch(
      selectedPremiseRooms(
        selectedRooms.map((item: any, index: number) => {
          return { ...item, isChecked: bool };
        })
      )
    );
  };

  const toggleProModal = () => {
    setOpenProModal(!isOpenProModal);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div style={{ margin: 0 }}>
          <Breadcrumb
            title="Users"
            breadcrumbItem={"Profile List"}
            state={{ isReload: true }}
            titleClick={"/users"}
          />
        </div>
        <ToastContainer />

        <Card>
          <CardBody>
            <Row className="">
              {/* General Information Section */}
              <Col xs={12} lg={6}>
                <div className="d-flex justify-content-start  gap-4">
                  <h5
                    style={{
                      color: "#000000",
                      fontWeight: "bold",
                      marginBottom: "1rem",
                    }}
                    className="mb-2 text-[20px]"
                  >
                    General Information
                  </h5>
                  {!loading && (
                    <div
                      className=""
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "65%",
                      }}
                    >
                      {isVacationMode ? (
                        <span className="font-size-12 fw-bold badge-soft-success badge bg-secondary">
                          Vacation Mode: ON
                        </span>
                      ) : (
                        <span className="font-size-12 fw-bold badge-soft-danger badge bg-secondary">
                          Vacation Mode: OFF
                        </span>
                      )}

                      <UserSettingModal
                        mobileGrid={mobileGrid}
                        tabGrid={tabGrid}
                        isSearchBar={isSearchBar}
                        noOfDeviceLimit={noOfDeviceLimit}
                        userId={params.id}
                      />
                    </div>
                  )}
                </div>
                <Row>
                  {profileDetails?.length > 0 ? (
                    <>
                      <Col xs={12} md={6}>
                        {profileDetails
                          .slice(0, 5)
                          .map((item: any, index: number) => (
                            <p
                              key={index}
                              style={{ color: "#858D9D", fontSize: 14 }}
                              className="my-2"
                            >
                              {item?.name}:{" "}
                              <span
                                style={{ fontWeight: "bold", color: "#000" }}
                              >
                                {item?.data}
                              </span>
                            </p>
                          ))}
                      </Col>
                      <Col xs={12} md={6}>
                        {profileDetails
                          .slice(5, 10)
                          .map((item: any, index: number) => (
                            <p
                              key={index}
                              style={{ color: "#858D9D", fontSize: 14 }}
                              className="my-2"
                            >
                              {item?.name}:{" "}
                              <span
                                style={{ fontWeight: "bold", color: "#000" }}
                              >
                                {item?.data}
                              </span>
                            </p>
                          ))}
                      </Col>
                    </>
                  ) : (
                    <Col
                      xs={12}
                      md={12}
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "155px" }}
                    >
                      <Spinner color="dark" />
                    </Col>
                  )}
                </Row>
              </Col>

              {/* Device Overview Section */}
              <Col xs={12} lg={6}>
                <div className="d-flex flex-wrap justify-content-start gap-4">
                  <h5
                    style={{
                      color: "#000000",
                      fontWeight: "bold",
                      marginBottom: "1rem",
                    }}
                    className="mb-2 text-[20px]"
                  >
                    Device Overview
                  </h5>
                  {!loading && (
                    <div className="m-0 d-flex align-items-center mb-2 gap-2 ">
                      <SharedUsersList
                        sharedList={sharedList}
                        parentList={parentList}
                      />
                    </div>
                  )}

                  <div
                    id="streak-btn"
                    className="ms-auto d-flex align-items-center gap-1 "
                  >
                    <h5
                      style={{
                        color: "#000000",
                        fontWeight: "bold",
                        marginBottom: 0,
                      }}
                      className="text-[15px]"
                    >
                      {streak.count}
                    </h5>

                    <box-icon type="solid" name="hot" color="orange" />
                  </div>

                  <Tooltip
                    anchorSelect="#streak-btn"
                    place="bottom"
                    content={streak.lastStreakDate}
                  />
                </div>

                <h5
                  style={{
                    color: "#000000",
                    fontWeight: "bold",
                    marginBottom: "1rem",
                  }}
                  className="mb-2 text-[20px]"
                ></h5>

                <Row>
                  {deviceDetails?.length > 0 ? (
                    <>
                      <table
                        className="table table-sm table-bordered text-center"
                        style={{ fontSize: "12px" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="p-1">Device</th>
                            <th className="p-1">total</th>
                            <th className="p-1">Online</th>
                            <th className="p-1">Offline</th>
                            <th className="p-1">Max Signal</th>
                            <th className="p-1">Min Signal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {deviceDetails.map((item, index) => (
                            <tr key={index}>
                              <td
                                className="p-1 fw-bold"
                                onClick={() => handleTabChange(item.key)}
                                style={{
                                  cursor: "pointer",
                                  transition: "0.2s",
                                }}
                                onMouseEnter={(e: any) => {
                                  e.target.style.color = "#0d6efd";
                                  e.target.style.textDecoration = "underline";
                                }}
                                onMouseLeave={(e: any) => {
                                  e.target.style.color = "";
                                  e.target.style.textDecoration = "none";
                                }}
                              >
                                {item.name}
                              </td>

                              <td className="p-1 fw-bold">{item.total}</td>

                              <td className="p-1 text-success fw-bold">
                                {item.online}
                              </td>

                              <td className="p-1 text-danger fw-bold">
                                {item.offline}
                              </td>
                              <td className="p-1">{item.max}</td>
                              <td className="p-1">{item.min}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <Col
                      xs={12}
                      md={12}
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "155px" }}
                    >
                      <Spinner color="dark" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row style={{ marginBottom: 20 }}>
          <Col lg={3}>
            <div className="">
              <label
                htmlFor="client_type"
                className="form-label d-flex align-items-center gap-2"
              >
                Premises ({premiseList?.length ?? 0})
                {selectedPremise?.isParent && (
                  <span className="badge bg-primary">Shared</span>
                )}
              </label>
              <select className="form-select" onChange={handlePremises}>
                {premiseList?.map((item: any, index: number) => {
                  return (
                    <option
                      value={item?.id}
                      key={index}
                      style={{
                        backgroundColor: item?.isParent ? "#e3f2fd" : "#ffffff",
                        color: item?.isParent ? "#1565c0" : "#000000",
                        fontWeight: item?.isParent ? "bold" : "normal",
                      }}
                    >
                      {item.name} {item?.isParent ? "(Shared)" : ""}
                    </option>
                  );
                })}
              </select>
              {selectedPremise?.isPro ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 5,
                    alignItems: "center",
                  }}
                >
                  <span className="font-size-11 badge-soft-success badge bg-secondary">
                    This premise is Pro.
                  </span>
                  <span
                    onClick={() => setOpenProModal(true)}
                    className="btn btn-sm btn-dark"
                  >
                    Remove Pro
                  </span>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 5,
                    alignItems: "center",
                  }}
                >
                  <span className="font-size-11 badge-soft-danger badge bg-secondary">
                    This premise is not Pro.
                  </span>
                  <span
                    onClick={() => setOpenProModal(true)}
                    className="btn btn-sm btn-dark"
                  >
                    Mark as Pro
                  </span>
                </div>
              )}
            </div>
          </Col>
          <Col lg={9} className="d-flex align-items-center">
            <div
              style={{
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: "#ffffff",
                width: "100%",
              }}
            >
              <Row className="g-1">
                {selectedRooms.map((item: any, index: number) => (
                  <Col
                    key={index}
                    lg={2}
                    md={3}
                    xs={6}
                    className="d-flex align-items-center"
                    style={{ fontSize: 14, cursor: "pointer" }}
                    onClick={() => handleRoomChecked(item)}
                  >
                    <input
                      type="checkbox"
                      style={{ marginRight: 10, accentColor: "#343A40" }}
                      checked={item.isChecked}
                      readOnly
                    />
                    {item.name}
                  </Col>
                ))}

                {/*Select All */}
                <Col
                  lg={2}
                  md={3}
                  xs={6}
                  className="d-flex align-items-center"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => handleRoomAllChecked(true)}
                >
                  <input
                    type="checkbox"
                    style={{ marginRight: 10, accentColor: "#343A40" }}
                    checked={selectedRooms.every((room: any) => room.isChecked)}
                    readOnly
                  />
                  Select All
                </Col>

                {/* Remove All */}
                <Col
                  lg={2}
                  md={3}
                  xs={6}
                  className="d-flex align-items-center"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => handleRoomAllChecked(false)}
                >
                  <input
                    type="checkbox"
                    style={{ marginRight: 10, accentColor: "#343A40" }}
                    checked={selectedRooms.every(
                      (room: any) => !room.isChecked
                    )}
                    readOnly
                  />
                  Remove All
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {selectedPremise?.isParent && (
          <div
            className="alert alert-primary d-flex align-items-center justify-content-between w-100 mb-3"
            role="alert"
          >
            <div className="d-flex align-items-center justify-content-center gap-2 ">
              <strong>Shared Premise :</strong>
              <div
                className="text-primary-emphasis"
                style={{ fontSize: "0.8rem", lineHeight: "1.2" }}
              >
                {selectedPremise?.name}
              </div>
            </div>
          </div>
        )}

        <Row style={{ marginBottom: 20 }}>
          <Col>
            <Nav
              className="rounded-pills"
              style={{
                backgroundColor: "#F1F1F1",
                width: "fit-content",
                borderRadius: 10,
              }}
            >
              {tabs.map(({ key, label }) => (
                <NavItem key={key}>
                  <NavLink
                    onClick={() => handleTabChange(key)}
                    className={classNames({ active: selectedTab === key })}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedTab === key ? "#343a40" : "#F1F1F1",
                      fontWeight: selectedTab === key ? 500 : 300,
                      borderRadius: 10,
                      fontSize: 16,
                      color: selectedTab === key ? "#ffffff" : "#000000",
                    }}
                  >
                    {label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Col>
        </Row>

        {/* Dynamically render the selected tab's component */}
        {tabs.map(({ key, component: Component }) =>
          selectedTab === key ? (
            <Component
              key={key}
              userId={params.id}
              selectedPremise={selectedPremise}
            />
          ) : null
        )}

        <Modal
          isOpen={isOpenProModal}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          // tabIndex="-1"
          toggle={toggleProModal}
        >
          <div className="modal-content">
            <ModalHeader style={{ justifyContent: "center" }}>
              {selectedPremise?.isPro ? "Remove Pro" : "Mark As Pro"}
            </ModalHeader>

            <ModalBody>
              <Label>{`Are you sure you want to ${
                selectedPremise?.isPro
                  ? "remove Pro from this premise?"
                  : "mark this premise as Pro?"
              }`}</Label>
            </ModalBody>
            <ModalFooter style={{ justifyContent: "right" }}>
              <button
                className="btn btn-outline-secondary"
                data-bs-target="#secondmodal"
                onClick={() => {
                  toggleProModal();
                  // tog_toggleModal1();
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-dark"
                data-bs-target="#secondmodal"
                onClick={() => {
                  changeProPremise();
                }}
                disabled={loading && loading}
              >
                {selectedPremise?.isPro ? "Remove Pro" : "Mark As Pro"}
              </button>
            </ModalFooter>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default ProfileList;
